// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VehicleSettingsModal .Modal-Body {
  display: flex;
  flex-direction: column;
}
.VehicleSettingsModal .Modal-Body .VehicleSettingsModal-Filters,
.VehicleSettingsModal .Modal-Body .VehicleSettingsModal-Columns {
  padding: 1rem;
}
.VehicleSettingsModal .Modal-Body .Field:before {
  background-color: #fff;
  margin-top: 1px;
}
.VehicleSettingsModal .Modal-Body .Field .VehicleSettingsModal-Columns {
  border: 1px solid var(--bs-primary);
  border-radius: var(--bs-border-radius);
}
.VehicleSettingsModal .Modal-Body .SwitchInput {
  justify-content: start;
  gap: 0.5rem;
}`, "",{"version":3,"sources":["webpack://./src/features/Vehicles/components/VehicleSettingsModal/styles.scss"],"names":[],"mappings":"AACE;EACE,aAAA;EACA,sBAAA;AAAJ;AAEI;;EAEE,aAAA;AAAN;AAGM;EACE,sBAAA;EACA,eAAA;AADR;AAGM;EACE,mCAAA;EACA,sCAAA;AADR;AAII;EACE,sBAAA;EACA,WAAA;AAFN","sourcesContent":[".VehicleSettingsModal {\n  .Modal-Body {\n    display: flex;\n    flex-direction: column;\n\n    .VehicleSettingsModal-Filters,\n    .VehicleSettingsModal-Columns {\n      padding: 1rem;\n    }\n    .Field {\n      &:before {\n        background-color: #fff;\n        margin-top: 1px;\n      }\n      .VehicleSettingsModal-Columns {\n        border: 1px solid var(--bs-primary);\n        border-radius: var(--bs-border-radius);\n      }\n    }\n    .SwitchInput {\n      justify-content: start;\n      gap: 0.5rem;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
